import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import PerfectScrollbar from 'perfect-scrollbar';
import swal from 'sweetalert2';
import { JournalDTO } from '../Models/Journal.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import {DatePipe} from '@angular/common';
declare const $: any;

@Component({
  selector: 'app-journal',
  templateUrl: './journal.component.html',
  providers: [SrubUpService]
})
export class JournalComponent implements OnInit {
  manageJournalList:any=[];
  journalListtemp:any=[];
  nextButtonDisabled: boolean;
  public loading = false;

  loginUserId: number;
  journal: JournalDTO;
  journals: Array<JournalDTO>;
  //related var's of event dto
  title: string;   //title serves as Name of journal event.
  surgeonname: string;
  procname: string;
  anaesthetist: string;
  teaminvolved: string;
  notes: string;
  start: string;
  end: string;
  className: string;
  startdate: string;      //start sholud be in form of "YYYY-MM-DDTHH:MM:SS"
  starttime: string;
  enddate: string;       //end sholud be in form of "YYYY-MM-DDTHH:MM:SS"
  endtime: string;

  constructor( public datepipe: DatePipe,private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.loginUserId = this.appUserDetails.UserId;
    this.journals = new Array<JournalDTO>();

  }

  getJournalsList() {
    var currDtTime = new Date().getTime();

    let journal: JournalDTO;

    this.loading = true;
    //new api
    this.scrubUpService.GetJournals(this.token, this.loginUserId).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.journalListtemp = x['Data']['Journals'];
        for(var i=0;i<this.journalListtemp.length;i++)
      {
        //console.log(this.journalListtemp[i]['Data']);
        for(var j=0; j<this.journalListtemp[i]['Data'].length;j++){
            this.manageJournalList.push(this.journalListtemp[i]['Data'][j]);
        }
      }

      //console.log(this.manageJournalList);

      this.manageJournalList.forEach(element => {
          journal = new JournalDTO();
          journal.journalId = element.JournalId;
          journal.title = element.Title;
          journal.surgeonName = element.Surgeon;
            let procedurelistItem:any=[];
                      for(var i=0;i<element['ProcedureList'].length;i++)
            {
              procedurelistItem.push(element['ProcedureList'][i]['Procedure']);
            }
          journal.journalProcedure = procedurelistItem.toString();
          journal.anaesthetist = element.Anaesthetist;
          journal.team = element.Team;
          journal.notes = element.Notes;
          journal.start = element.StartDate ;
          journal.end = element.EndDate;

        //   let startdate = this.datepipe.transform(element.StartDate, 'yyyy-MM-dd');
        //   let startdatetime = startdate.concat("T",element.StartTime.toString());
        //   let enddate = this.datepipe.transform(element.EndDate, 'yyyy-MM-dd');
        //  let enddatetime = enddate.concat("T",element.EndTime.toString());

//console.log(enddatetime);
          //console.log(element.EndDate.concat(element.EndTime.toString()));
          if (new Date(element.EndDate).getTime() < currDtTime) {
            journal.className = 'event-default';
          }
          else if ((new Date(element.StartDate).getTime() < currDtTime) && (currDtTime < new Date(element.EndDate).getTime())) {
            journal.className = 'event-green';
          }
          else {
            journal.className = 'event-azure';
          }
          this.journals.push(journal);
        });
        // this.journals.forEach(element => {
        //   $('#fullCalendar').fullCalendar('renderEvent', element, true);
        // });
        $('#fullCalendar').fullCalendar('renderEvents',this.journals, true);
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  ngOnInit() {
    this.getJournalsList();
    const $calendar = $('#fullCalendar');

    const today = new Date();
    const y = today.getFullYear();
    const m = today.getMonth();
    const d = today.getDate();

    $(function () {
      $('#datetimepicker3').datetimepicker({
        pickDate: false
      });
      
    });

    $calendar.fullCalendar({
      viewRender: function (view: any, element: any) {
        // We make sure that we activate the perfect scrollbar when the view isn't on Month
        var elem = $(element).find('.fc-scroller')[0];
        let ps = new PerfectScrollbar(elem);
       
      },
      header: {
        left: 'month, agendaWeek, agendaDay',
        center: 'title',
        right: 'prev, next, today'
      },
      height: 815,
      defaultDate: today,
      selectable: false,
      selectHelper: false,
      views: {
        month: { // name of view
          titleFormat: 'MMMM YYYY'
          // other view-specific options here
        },
        week: {
          titleFormat: ' MMMM D YYYY'
        },
        day: {
          titleFormat: 'D MMM, YYYY'
        }
       
      },
      timeFormat: 'hh:mm a',
      selectAllow: false,
      editable: false,
      eventLimit: true, // allow "more" link when too many events

      select: function (start: any, end: any) {
        //values of start and end will be choosen in the calendar

      },


      eventClick: function (eventObj) {
        console.log(eventObj);
        if (eventObj.url) {
          window.open(eventObj.url);
          return false; // prevents browser from following link in current tab.
        }
        else {
          swal(
            {
              //title: eventObj.Start+"-"+eventObj.End,
              html: '<div class="well"><strong style="font-size:18px;">Suregon name : </strong>' + eventObj.surgeonName + '<br><br>' +
                '<strong style="font-size:18px;">Procedure : </strong>' + eventObj.journalProcedure + '<br><br>' +
                '<strong style="font-size:18px;">Anaesthetist : </strong>' + eventObj.anaesthetist + '<br><br>' +
                '<strong style="font-size:18px;">Team Involved : </strong>' + eventObj.team + '<br><br>' +
                '<strong style="font-size:18px;">Notes : </strong>' + eventObj.notes + '<br><br></div>'
            }
          ).catch(swal.noop);
        }
      },

      events: this.journals

    });

  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/journal/journal.component.ts